import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { COMPANIES_PATHS } from '../../../companies/companies';
import { environment } from '../../../../../environments/environment.prod';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class UsersListComponent implements OnInit {
  public environment = environment;
  public COMPANIES_PATHS = COMPANIES_PATHS;

  @Input() userExpanded;
  @Input() filterData;
  @Input() userDataIsLoaded;
  @Input() userListFiltered;
  @Input() paginationBlock;
  @Input() emptyMessage;
  @Output() onChangeUserExpanded = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes.userListFiltered);
  }
}
